import { ErrorBoundary } from 'react-error-boundary';

import { StyledThemeProvider, rgsTheme } from '@pulse-web-ui/theme';
import { Toaster } from '@pulse-web-ui/toast';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';

import './i18n/config';

import { ErrorDefault } from '@shared/ui/error-default';

import { AppContent } from './app-content';
import { Layout } from './layout';
import { WebAnalytic } from './web-analytic';

export const App = () => {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <>
      <WebAnalytic />
      <StyledThemeProvider theme={rgsTheme}>
        <Layout>
          <ErrorBoundary
            onReset={reset}
            FallbackComponent={ErrorDefault}
          >
            <Toaster
              size={{ width: 300 }}
              position={{ top: 16, right: 16 }}
            >
              <AppContent />
            </Toaster>
          </ErrorBoundary>
        </Layout>
      </StyledThemeProvider>
    </>
  );
};

export default App;
